import React from "react";
import PropTypes from "prop-types";
import Loading from "../../components/Loading";

import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { getProfileFetch } from "../../actions";

// import classes from "./ProtectedRoute.module.css";

class ProtectedRoute extends React.Component {
    componentDidMount() {
        if (this.props.loggedIn === null) {
            this.props.getProfileFetch(true);
        }
    }

    render() {
        const { component: Component, ...rest } = this.props;

        return (
            <Route
                {...rest}
                render={props => {
                    if (this.props.loggedIn === null) {
                        return <Loading />;
                    } else if (this.props.loggedIn === true) {
                        return <Component {...props} />;
                    } else {
                        return (
                            <Redirect
                                to={{
                                    pathname: "/login",
                                    state: {
                                        from: this.props.location
                                    }
                                }}
                            />
                        );
                    }
                }}
            />
        );
    }
}

ProtectedRoute.propTypes = {
    loggedIn: PropTypes.bool,
    getProfileFetch: PropTypes.func,
    component: PropTypes.any,
    location: PropTypes.object
};

const mapStateToProps = state => {
    return {
        loggedIn: state.user.loggedIn
    };
};

export default connect(mapStateToProps, { getProfileFetch })(ProtectedRoute);
